
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("jIyMJ", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("eiiG2")).Trans; });
$parcel$export(module.exports, "withTranslation", function () { return (parcelRequire("R5cjU")).withTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("lWlYk")).initReactI18next; });

var $eiiG2 = parcelRequire("eiiG2");

var $7PSw9 = parcelRequire("7PSw9");

var $foNhC = parcelRequire("foNhC");

var $R5cjU = parcelRequire("R5cjU");

var $7yYtW = parcelRequire("7yYtW");

var $kWgTT = parcelRequire("kWgTT");

var $dLukE = parcelRequire("dLukE");

var $csCyp = parcelRequire("csCyp");

var $lWlYk = parcelRequire("lWlYk");

var $9sE0M = parcelRequire("9sE0M");

var $j5haJ = parcelRequire("j5haJ");

var $6W3SM = parcelRequire("6W3SM");
const $e5ad1bf4d72b4194$export$324d90190a8b822a = ()=>"";
const $e5ad1bf4d72b4194$export$2da9be4cfdb689b1 = ()=>"";
const $e5ad1bf4d72b4194$export$98e628dec113755e = ()=>"";
const $e5ad1bf4d72b4194$export$2e6c959c16ff56b8 = ()=>"";
const $e5ad1bf4d72b4194$export$4e35d5c922a95490 = ()=>"";
const $e5ad1bf4d72b4194$export$720a3b9db04b7a0f = ()=>"";

});
parcelRegister("eiiG2", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $a6813bfe5c2b6212$export$8d6a9236f2e3f2ce; });

var $aX1RZ = parcelRequire("aX1RZ");

var $7PSw9 = parcelRequire("7PSw9");

var $6W3SM = parcelRequire("6W3SM");
var $j5haJ = parcelRequire("j5haJ");
function $a6813bfe5c2b6212$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $aX1RZ.useContext)((0, $6W3SM.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $j5haJ.getI18n)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $7PSw9.Trans)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}

});
parcelRegister("7PSw9", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $5b4795e2b9779798$export$8d6a9236f2e3f2ce; });

var $hXAuH = parcelRequire("hXAuH");

var $aX1RZ = parcelRequire("aX1RZ");

var $fcwCx = parcelRequire("fcwCx");

var $3WqtM = parcelRequire("3WqtM");

var $9sE0M = parcelRequire("9sE0M");

var $j5haJ = parcelRequire("j5haJ");
function $5b4795e2b9779798$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $5b4795e2b9779798$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $5b4795e2b9779798$var$getAsArray(children) : children;
}
function $5b4795e2b9779798$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $aX1RZ.isValidElement)(child));
}
function $5b4795e2b9779798$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $5b4795e2b9779798$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $5b4795e2b9779798$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $5b4795e2b9779798$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $aX1RZ.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $5b4795e2b9779798$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $3WqtM.warn)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $3WqtM.warn)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $3WqtM.warn)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $5b4795e2b9779798$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $5b4795e2b9779798$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($5b4795e2b9779798$var$hasChildren(child)) getData($5b4795e2b9779798$var$getChildren(child));
            else if (typeof child === "object" && !(0, $aX1RZ.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $fcwCx.default).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $5b4795e2b9779798$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $5b4795e2b9779798$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $aX1RZ.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $aX1RZ.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($aX1RZ))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($hXAuH)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $5b4795e2b9779798$var$getAsArray(reactNode);
        const astNodes = $5b4795e2b9779798$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $5b4795e2b9779798$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $aX1RZ.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $5b4795e2b9779798$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($5b4795e2b9779798$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $aX1RZ.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $aX1RZ.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $aX1RZ.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $5b4795e2b9779798$var$getAsArray(children || []));
    return $5b4795e2b9779798$var$getChildren(result[0]);
}
function $5b4795e2b9779798$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $j5haJ.getI18n)();
    if (!i18n) {
        (0, $3WqtM.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $9sE0M.getDefaults)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $5b4795e2b9779798$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = $5b4795e2b9779798$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $aX1RZ.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("hXAuH", function(module, exports) {
function $d13441536a24a25a$var$_extends() {
    module.exports = $d13441536a24a25a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $d13441536a24a25a$var$_extends.apply(this, arguments);
}
module.exports = $d13441536a24a25a$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fcwCx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b11147cb742ea30e$export$2e2bcd8739ae039; });

var $ld1hX = parcelRequire("ld1hX");
var $b11147cb742ea30e$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $b11147cb742ea30e$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($ld1hX)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($b11147cb742ea30e$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $b11147cb742ea30e$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $b11147cb742ea30e$var$i = /^\s*$/, $b11147cb742ea30e$var$s = Object.create(null);
function $b11147cb742ea30e$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($b11147cb742ea30e$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $b11147cb742ea30e$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $b11147cb742ea30e$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($b11147cb742ea30e$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $b11147cb742ea30e$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $b11147cb742ea30e$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $b11147cb742ea30e$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $b11147cb742ea30e$var$a("", t);
        }, "");
    }
};
var $b11147cb742ea30e$export$2e2bcd8739ae039 = $b11147cb742ea30e$var$c;

});
parcelRegister("ld1hX", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRegister("3WqtM", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $2deb542107eb647f$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $2deb542107eb647f$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $2deb542107eb647f$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $2deb542107eb647f$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $2deb542107eb647f$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $2deb542107eb647f$export$be63e0664592e141; });
function $2deb542107eb647f$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $2deb542107eb647f$var$alreadyWarned = {};
function $2deb542107eb647f$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $2deb542107eb647f$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $2deb542107eb647f$var$alreadyWarned[args[0]] = new Date();
    $2deb542107eb647f$export$c106dd0671a0fc2d(...args);
}
const $2deb542107eb647f$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $2deb542107eb647f$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $2deb542107eb647f$var$loadedClb(i18n, cb));
}
function $2deb542107eb647f$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $2deb542107eb647f$var$loadedClb(i18n, cb));
}
function $2deb542107eb647f$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $2deb542107eb647f$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $2deb542107eb647f$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $2deb542107eb647f$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $2deb542107eb647f$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});

parcelRegister("9sE0M", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $6e35c40947963d36$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $6e35c40947963d36$export$212bb2fc580a90a8; });

var $77RaL = parcelRequire("77RaL");
let $6e35c40947963d36$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $77RaL.unescape
};
function $6e35c40947963d36$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $6e35c40947963d36$var$defaultOptions = {
        ...$6e35c40947963d36$var$defaultOptions,
        ...options
    };
}
function $6e35c40947963d36$export$212bb2fc580a90a8() {
    return $6e35c40947963d36$var$defaultOptions;
}

});
parcelRegister("77RaL", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $53026ecf1b091ac2$export$e8bacd2802a88316; });
const $53026ecf1b091ac2$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $53026ecf1b091ac2$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $53026ecf1b091ac2$var$unescapeHtmlEntity = (m)=>$53026ecf1b091ac2$var$htmlEntities[m];
const $53026ecf1b091ac2$export$e8bacd2802a88316 = (text)=>text.replace($53026ecf1b091ac2$var$matchHtmlEntity, $53026ecf1b091ac2$var$unescapeHtmlEntity);

});


parcelRegister("j5haJ", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $de4bcdf99f6a738d$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $de4bcdf99f6a738d$export$64af334f494c2f47; });
let $de4bcdf99f6a738d$var$i18nInstance;
function $de4bcdf99f6a738d$export$a039134f2fc7e0(instance) {
    $de4bcdf99f6a738d$var$i18nInstance = instance;
}
function $de4bcdf99f6a738d$export$64af334f494c2f47() {
    return $de4bcdf99f6a738d$var$i18nInstance;
}

});


parcelRegister("6W3SM", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $50cb2bd5275a3f57$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $50cb2bd5275a3f57$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $50cb2bd5275a3f57$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("9sE0M")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("j5haJ")).getI18n; });

var $aX1RZ = parcelRequire("aX1RZ");

var $9sE0M = parcelRequire("9sE0M");

var $j5haJ = parcelRequire("j5haJ");

var $lWlYk = parcelRequire("lWlYk");
const $50cb2bd5275a3f57$export$5603ab5ced17ce64 = (0, $aX1RZ.createContext)();
class $50cb2bd5275a3f57$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $50cb2bd5275a3f57$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $50cb2bd5275a3f57$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $50cb2bd5275a3f57$export$704200e5d0b9e8f() {
    const i18n = (0, $j5haJ.getI18n)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRegister("lWlYk", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $ff900eefdf32ceac$export$ae7e14d40d89f296; });

var $9sE0M = parcelRequire("9sE0M");

var $j5haJ = parcelRequire("j5haJ");
const $ff900eefdf32ceac$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $9sE0M.setDefaults)(instance.options.react);
        (0, $j5haJ.setI18n)(instance);
    }
};

});



parcelRegister("foNhC", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $b35f53880d2f9154$export$9fc83ad70ead8663; });

var $aX1RZ = parcelRequire("aX1RZ");

var $6W3SM = parcelRequire("6W3SM");
var $j5haJ = parcelRequire("j5haJ");
var $9sE0M = parcelRequire("9sE0M");

var $3WqtM = parcelRequire("3WqtM");
const $b35f53880d2f9154$var$usePrevious = (value, ignore)=>{
    const ref = (0, $aX1RZ.useRef)();
    (0, $aX1RZ.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $b35f53880d2f9154$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $aX1RZ.useContext)((0, $6W3SM.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $j5haJ.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $6W3SM.ReportNamespaces)();
    if (!i18n) {
        (0, $3WqtM.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $3WqtM.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $9sE0M.getDefaults)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $3WqtM.hasLoadedNamespace)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $aX1RZ.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $b35f53880d2f9154$var$usePrevious(joinedNS);
    const isMounted = (0, $aX1RZ.useRef)(true);
    (0, $aX1RZ.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $3WqtM.loadLanguages)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $3WqtM.loadNamespaces)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $aX1RZ.useRef)(true);
    (0, $aX1RZ.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $3WqtM.loadLanguages)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $3WqtM.loadNamespaces)(i18n, namespaces, ()=>resolve());
    });
}

});

parcelRegister("R5cjU", function(module, exports) {

$parcel$export(module.exports, "withTranslation", function () { return $09f8fb8273055ee8$export$2dcb0053efd21124; });

var $aX1RZ = parcelRequire("aX1RZ");

var $foNhC = parcelRequire("foNhC");

var $3WqtM = parcelRequire("3WqtM");
function $09f8fb8273055ee8$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $foNhC.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $aX1RZ.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $3WqtM.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $aX1RZ.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $aX1RZ.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRegister("7yYtW", function(module, exports) {

var $foNhC = parcelRequire("foNhC");
function $581a9fd95725174d$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $foNhC.useTranslation)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRegister("kWgTT", function(module, exports) {

var $aX1RZ = parcelRequire("aX1RZ");

var $6W3SM = parcelRequire("6W3SM");
function $f3e6558645d0b0ed$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $aX1RZ.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $aX1RZ.createElement)((0, $6W3SM.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRegister("dLukE", function(module, exports) {

var $aX1RZ = parcelRequire("aX1RZ");

var $csCyp = parcelRequire("csCyp");

var $6W3SM = parcelRequire("6W3SM");

var $3WqtM = parcelRequire("3WqtM");
function $a0573179722ee346$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $csCyp.useSSR)(initialI18nStore, initialLanguage);
            return (0, $aX1RZ.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $6W3SM.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $3WqtM.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRegister("csCyp", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $9126018f26fc77b6$export$3526fb65ade8d8b7; });

var $aX1RZ = parcelRequire("aX1RZ");

var $6W3SM = parcelRequire("6W3SM");
var $j5haJ = parcelRequire("j5haJ");
function $9126018f26fc77b6$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $aX1RZ.useContext)((0, $6W3SM.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $j5haJ.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});




//# sourceMappingURL=Homepage.8b6faa5f.js.map
